import { createContext } from "react";

const CaseContext = createContext({});

export default CaseContext;
